import React from 'react';
import PropTypes from 'prop-types';
import s from './ReviewStars.scss';
import classNames from 'classnames';

export default class ReviewStars extends React.Component {
  static propTypes = {
    fullStars: PropTypes.number.isRequired,
    size: PropTypes.oneOf(['small', 'medium']),
    dataHook: PropTypes.string,
  };

  static defaultProps = {
    size: 'small',
    dataHook: 'review-stars-wrapper',
  };

  render() {
    const { fullStars, size } = this.props;

    const reviewsScoreStars = () => {
      let numOfStars = Math.round(fullStars);
      numOfStars = numOfStars < 0 ? 0 : numOfStars;
      const result = new Array(numOfStars).fill(1);
      for (let i = numOfStars; i < 5; i++) {
        result.push(0);
      }
      return result.map((item, index) => {
        return item ? (
          <div
            key={index}
            data-hook="full-review-star"
            className={classNames(s.star, s.fullStar)}
          />
        ) : (
          <div
            key={index}
            data-hook="empty-review-star"
            className={classNames(s.star, s.emptyStar)}
          />
        );
      });
    };

    return (
      <span
        data-hook={this.props.dataHook}
        className={classNames(s.reviewStars, s[size])}
      >
        {reviewsScoreStars()}
      </span>
    );
  }
}
